import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { appRoutesObj } from "src/app.paths";

interface IProps {
  children: ReactElement;
}
function LayoutRegisterPageComponent({ children }: IProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="overflow-x-hidden">
      <img
        onClick={() => navigate(appRoutesObj.getBasePath())}
        src="/assets/images/alfredo-logo-white.svg"
        alt=""
        className="absolute left-6 top-11 z-50 h-8 mobile:h-6 mobile:left-3.5 mobile:top-3.5 cursor-pointer"
      />
      <div className="absolute top-0 left-0 z-10 bg-mint-500 h-[90vh] mobile:h-[400px] tablet:h-[500px] w-screen"></div>
      <div className="bg-layoutBg bg-cover bg-no-repeat bg-top absolute top-5 z-20 h-full w-[100%] tablet:h-[500px] mobile:top-14 mobile:h-[450px] mobile:w-[100%] overflow-x-hidden"></div>
      <div className="bg-zinc50">{children}</div>
      <div className="flex flex-col items-end justify-center h-[181px] mobile:h-[73px] bg-zinc-50 pl-8 gap-8 mobile:gap-2 drop-shadow-[0_0px_10px_rgba(0,0,0,0.05)]">
        <img alt="" src="/assets/images/logo.svg" className="h-16 mobile:h-6" />
        <p className="font-arMedium text-sm text-blue-600 mobile:font-ar mobile:text-[8px]">
          {t("layout.component.allrightsreserved")}
        </p>
      </div>
    </div>
  );
}

export default LayoutRegisterPageComponent;
